/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IoIosArrowForward } from 'react-icons/io';

import { useEvieAppContext } from '../EvieAppProvider';
import { useToggle } from 'utils/hooks/useToggle';
import { handleTrackEvent } from 'components/evieOnboarding/utils/handleTrackEvent';
import doctorImage from 'assets/images/doctor-image.png';
import phoneIcon from 'assets/images/phone-icon.png';

import AlertModal from 'components/AlertModal';
import AppointmentSchedulerModal from '../AppointmentSchedulerModal';

const ScheduleCallCard = ({ eventId, eventKey, eventType, eventTrigger, assistant }) => {
  const { t } = useTranslation();
  const {
    i18n: { language },
  } = useTranslation();
  const { refetch, isAppointmentScheduled, appointmentDate } = useEvieAppContext();

  const [openCallScheduleModal, setOpenCallScheduleModal] = useToggle(false);
  const [openAlertModal, setOpenAlertModal] = useToggle(false);

  const handleOpenCallScheduleModal = () => {
    if (assistant) {
      handleTrackEvent('Chat action clicked', { type: eventType, key: eventKey, trigger: eventTrigger });
    }
    if (isAppointmentScheduled) {
      setOpenAlertModal();
    } else {
      setOpenCallScheduleModal();
    }
  };

  return (
    <>
      {isAppointmentScheduled ? (
        <button type="button" style={{ width: '100%' }} onClick={handleOpenCallScheduleModal}>
          <div className="schedule-call-card schedule-call-card--scheduled">
            <div className="schedule-call-card__image">
              <img src={phoneIcon} alt="scheduled call" />
            </div>
            <div className="schedule-call-card__content">
              <p className="schedule-call-card__content-title">{t('evieApp.scheduleCall.scheduled.title')}</p>
            </div>
            <div className="schedule-call-card__arrow">
              <IoIosArrowForward size={28} />
            </div>
          </div>
        </button>
      ) : (
        <button type="button" style={{ width: '100%' }} onClick={handleOpenCallScheduleModal}>
          <div className="schedule-call-card">
            <div className="schedule-call-card__image">
              <img src={doctorImage} alt="schedule call" />
            </div>
            <div className="schedule-call-card__content">
              <p className="schedule-call-card__content-title">{t('evieApp.scheduleCall.title')}</p>
              <p className="schedule-call-card__content-subtitle">{t('evieApp.scheduleCall.subtitle')}</p>
            </div>
            <div className="schedule-call-card__arrow">
              <IoIosArrowForward size={28} />
            </div>
          </div>
        </button>
      )}
      {openCallScheduleModal ? (
        <AppointmentSchedulerModal
          isOpen={openCallScheduleModal}
          onClose={setOpenCallScheduleModal}
          refetch={refetch}
          eventId={eventId}
          eventKey={eventKey}
        />
      ) : null}
      {openAlertModal ? (
        <AlertModal
          open={openAlertModal}
          onCancelAction={setOpenAlertModal}
          onConfirmAction={setOpenAlertModal}
          title={t('evieApp.scheduleCall.scheduled.modal.title')}
          description={`${t('evieApp.scheduleCall.scheduled.modal.message')} ${appointmentDate
            .locale(language)
            .format('dddd, MMMM D - h:mm a')}`}
          labelConfirm={t('evieApp.scheduleCall.scheduled.modal.ok')}
          customAlertModal
          category="evie-primary"
        />
      ) : null}
    </>
  );
};

ScheduleCallCard.defaultProps = {
  eventId: 3073574,
  eventKey: 'discovery_call',
  eventType: '',
  eventTrigger: '',
  assistant: false,
};

ScheduleCallCard.propTypes = {
  eventId: PropTypes.number,
  eventKey: PropTypes.string,
  eventType: PropTypes.string,
  eventTrigger: PropTypes.string,
  assistant: PropTypes.bool,
};

export default ScheduleCallCard;
